import { axiosBase, errorHandler } from "./axios";

const getExpenseParams = (data: any) => {
  return axiosBase.get("expense/list", { params: data })
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const createExpense = (data: any) => {
  return axiosBase.post("expense/save", data)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const deleteExpense = (data: any) => {
  return axiosBase.delete(`expense/delete/${data}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

const getExpenseView = (data: any) => {
  const id = typeof data === 'string' ? data : data.id;
  return axiosBase.get(`expense/view/${id}`)
    .then((response) => response.data)
    .catch((error) => errorHandler(error));
}

export const expenseService = {
  getExpenseParams,
  createExpense,
  deleteExpense,
  getExpenseView,
};
